var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserTesting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1501 26.1L51.7001 36.55C49.6001 45.575 45.4501 49.225 37.6501 48.475C36.4001 48.375 35.0501 48.15 33.6001 47.8L29.4001 46.8C18.975 44.325 15.75 39.175 18.2 28.725L20.65 18.25C21.15 16.125 21.75 14.275 22.5 12.75C25.4251 6.70002 30.4001 5.07502 38.7501 7.05002L42.9251 8.02502C53.4001 10.475 56.6001 15.65 54.1501 26.1Z",
    stroke: "#25282B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.65 48.475C36.1 49.525 34.15 50.4 31.775 51.175L27.825 52.4751C17.8999 55.6751 12.6749 53.0001 9.44988 43.0751L6.24988 33.2C3.04988 23.275 5.69988 18.025 15.6249 14.825L19.5749 13.525C20.5999 13.2 21.5749 12.925 22.4999 12.75C21.7499 14.275 21.1499 16.125 20.6499 18.25L18.1999 28.725C15.7499 39.175 18.9749 44.325 29.4 46.8L33.5999 47.8001C35.0499 48.1501 36.4 48.375 37.65 48.475Z",
    stroke: "#25282B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6001 21.3251L43.7251 24.4001",
    stroke: "#25282B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1499 31L36.3999 32.85",
    stroke: "#25282B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserTesting);
export default __webpack_public_path__ + "static/media/user_testing.a434de701b724f1ea0fa53081eca13d3.svg";
export { ForwardRef as ReactComponent };